import { makeStyles, Theme, } from '@material-ui/core/styles';

import { orange, }  from 'styles/abstract/variables';

export const makeQuantityInputStyles = makeStyles({
    root: {
        padding: '0rem 0.2rem 0rem 1rem',
        width: '4.8rem',
        height: '2.75rem'
    },
}, { index: 1, });

export const makeOutlinedInputClasses = makeStyles((theme: Theme) => ({
    root: {
        marginRight: '1rem',

        [theme.breakpoints.down('md')]: {
            margin: theme.spacing(0, 0, 2, 0),
        },

        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: orange,
        },

        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: orange,
        },
    },
}));
